import React from 'react';
import FeesPage from '../components/FeesPage';
import WhatsAppButton from '../components/WhatsAppButton';

function Fees() {
  return (
    <div className="home">
      <FeesPage />
      <WhatsAppButton />
    </div>
  );
}

export default Fees;
